import React, { useState } from 'react'
import './RegistroStyle.css';
import { MiFooter } from '../../components/footer/MiFooter'
import HeaderHome from '../../components/headerHome/HeaderHome';
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import { FormularioRegistroEstandar } from '../../components/Registro/FormularioRegistroEstandar';

export const Registro = (props) => {
  /* A hook that is used to change the state of the menu. */
  const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)

  const closeMenu = () => {
    if (MenuLateral === true) {
      setMenuLateral(false)
    }
  }

  return (
    <>
      <div className='Registro' onClick={closeMenu}>
        <div className='headerRegistro'>
          <HeaderHome />
        </div>
        <div className="bodyRegistro">
          <div className='contentBodyRegistro'>
            <FormularioRegistroEstandar/>
          </div>
        </div>
        <div className='footerRegistro'>
          <MiFooter />
        </div>
      </div>
    </>
  )
}
